import React, { Fragment, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
// import logo200Image from 'assets/img/logo/logo_200.png';
import sidebarBgImage from '../../assets/img/sidebar/sidebar-4.jpg';
import SourceLink from '../SourceLink';
import { MdKeyboardArrowDown } from 'react-icons/md';
import { NavLink, useNavigate } from 'react-router-dom';
import { MdPower } from 'react-icons/md';
import {
    // UncontrolledTooltip,
    Collapse,
    Nav,
    Navbar,
    NavItem,
    NavLink as BSNavLink,
} from 'reactstrap';
import bn from '../../utils/bemnames';
// config
import { removeAuthorization } from '../../config/axios';
// import reducers
import { removeAuthAccount } from '../../redux/reducers/auth';
// lib
import toastAlert from '../../lib/toastAlert';

// import routes
import routers from '../../Routes';

const sidebarBackground = {
    backgroundImage: `url("${sidebarBgImage}")`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    // backgroundColor: '#000000'
};

const bem = bn.create('sidebar');

const Sidebar = () => {

    // hooks
    const navigate = useNavigate()
    const dispatch = useDispatch()
    // state 
    const [state, setState] = useState({});
    // redux-state
    const { role, restriction } = useSelector(state => state?.auth);

    const handleClick = (name) => setState({ [name]: (state[name]) ? !state[name] : true })

    const handleLogout = () => {
        removeAuthorization();
        toastAlert('success', 'Logout Successfully', 'logout')
        removeAuthAccount(dispatch)
        navigate('/login')
    }

    return (
        <aside className={bem.b()} data-image={sidebarBgImage}>
            <div className={bem.e('background')} style={sidebarBackground} />
            <div className={bem.e('content')}>
                <Navbar>
                    <SourceLink className="navbar-brand d-flex">
                        {/* <img
                            src={logo200Image}
                            width="40"
                            height="30"
                            className="pr-2"
                            alt=""
                        /> */}
                        <span className="text-white">
                            ADMIN PANEL
                        </span>
                    </SourceLink>
                </Navbar>
                <Nav vertical>
                    {
                        routers && routers.length > 0 && routers.map((item, key) => {
                            if (item && item.path !== null && item.isSideMenu === true) {
                                if (role === 'superadmin') {
                                    return (
                                        <NavItem key={key} className={bem.e('nav-item')} onClick={() => handleClick(item.name)}>
                                            <BSNavLink
                                                id={`navItem-${item.name}-${key}`}
                                                className="text-uppercase"
                                                tag={NavLink}
                                                to={item.path}
                                                activeClassName="active"
                                                exact={true}
                                            >
                                                <item.icon className={bem.e('nav-item-icon')} />
                                                <span className="">{item.name}</span>
                                            </BSNavLink>
                                        </NavItem>
                                    )
                                } else if (role === 'subadmin' && restriction && restriction?.includes(item.path)) {
                                    return (
                                        <NavItem key={key} className={bem.e('nav-item')} onClick={() => handleClick(item.name)}>
                                            <BSNavLink
                                                id={`navItem-${item.name}-${key}`}
                                                className="text-uppercase"
                                                tag={NavLink}
                                                to={item.path}
                                                activeClassName="active"
                                                exact={true}
                                            >
                                                <item.icon className={bem.e('nav-item-icon')} />
                                                <span className="">{item.name}</span>
                                            </BSNavLink>
                                        </NavItem>
                                    )
                                } else {
                                    return null
                                }
                            } else if (item && item.path === null && item.isSideMenu === true) {
                                let isExtract = (state && state[item.name]) ? state[item.name] : false;
                                if (role === 'superadmin') {
                                    return (
                                        <Fragment>
                                            <NavItem
                                                className={bem.e('nav-item')}
                                                onClick={() => handleClick(item.name)}
                                                key={key}
                                            >
                                                <BSNavLink className={bem.e('nav-item-collapse')}>
                                                    <div className="d-flex">
                                                        <item.icon className={bem.e('nav-item-icon')} />
                                                        <span className=" align-self-start">{item.name}</span>
                                                    </div>
                                                    <MdKeyboardArrowDown
                                                        className={bem.e('nav-item-icon')}
                                                        style={{
                                                            padding: 0,
                                                            transform: isExtract
                                                                ? 'rotate(0deg)'
                                                                : 'rotate(-90deg)',
                                                            transitionDuration: '0.3s',
                                                            transitionProperty: 'transform',
                                                        }}
                                                    />
                                                </BSNavLink>
                                            </NavItem>
                                            <Collapse isOpen={isExtract}>
                                                {
                                                    item && item.menuGroup.length > 0 && item.menuGroup.map((items, index) => {
                                                        if (items.isGroupMenu === true) {
                                                            return (
                                                                <NavItem key={index} className={bem.e('nav-item')}>
                                                                    <BSNavLink
                                                                        id={`navItem-${items.name}-${index}`}
                                                                        className="text-uppercase"
                                                                        tag={NavLink}
                                                                        to={items.path}
                                                                        activeClassName="active"
                                                                        exact={false}
                                                                    >
                                                                        <items.icon className={bem.e('nav-item-icon')} />
                                                                        <span className="">{items.name}</span>
                                                                    </BSNavLink>
                                                                </NavItem>
                                                            )
                                                        } else {
                                                            return null
                                                        }
                                                    })
                                                }
                                            </Collapse>
                                        </Fragment>
                                    )
                                } else if (role === 'subadmin') {
                                    return (
                                        <Fragment>
                                            {
                                                item?.menuGroup?.some((el) => restriction.includes(el.path)) && (
                                                    <NavItem
                                                        className={bem.e('nav-item')}
                                                        onClick={() => handleClick(item.name)}
                                                        key={key}
                                                    >
                                                        <BSNavLink className={bem.e('nav-item-collapse')}>
                                                            <div className="d-flex">
                                                                <item.icon className={bem.e('nav-item-icon')} />
                                                                <span className=" align-self-start">{item.name}</span>
                                                            </div>
                                                            <MdKeyboardArrowDown
                                                                className={bem.e('nav-item-icon')}
                                                                style={{
                                                                    padding: 0,
                                                                    transform: isExtract
                                                                        ? 'rotate(0deg)'
                                                                        : 'rotate(-90deg)',
                                                                    transitionDuration: '0.3s',
                                                                    transitionProperty: 'transform',
                                                                }}
                                                            />
                                                        </BSNavLink>
                                                    </NavItem>
                                                )
                                            }

                                            <Collapse isOpen={isExtract}>
                                                {
                                                    item && item.menuGroup.length > 0 && item.menuGroup.map((items, index) => {
                                                        if (items.isGroupMenu === true) {
                                                            if (restriction?.includes(items.path)) {
                                                                return (
                                                                    <NavItem key={index} className={bem.e('nav-item')}>
                                                                        <BSNavLink
                                                                            id={`navItem-${items.name}-${index}`}
                                                                            className="text-uppercase"
                                                                            tag={NavLink}
                                                                            to={items.path}
                                                                            activeClassName="active"
                                                                            exact={false}
                                                                        >
                                                                            <items.icon className={bem.e('nav-item-icon')} />
                                                                            <span className="">{items.name}</span>
                                                                        </BSNavLink>
                                                                    </NavItem>
                                                                )
                                                            } else {
                                                                return null
                                                            }
                                                        } else {
                                                            return null
                                                        }
                                                    })
                                                }
                                            </Collapse>
                                        </Fragment>
                                    )
                                } else {
                                    return null
                                }

                            } else {
                                return null
                            }
                        })
                    }
                    <NavItem
                        className={bem.e('nav-item')}
                        onClick={handleLogout}
                    >
                        <BSNavLink className={bem.e('nav-item-collapse')}>
                            <div className="d-flex">
                                <MdPower className={bem.e('nav-item-icon')} />
                                <span className=" align-self-start">Logout</span>
                            </div>
                        </BSNavLink>
                    </NavItem>
                </Nav>
            </div>
        </aside>
    );

}

export default Sidebar;
